var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "stock-introduction area"
  }, [_vm._m(0), _c("main", {
    staticClass: "stock-introduction__main"
  }, [_vm._l(_vm.introductionList, function (item, index) {
    return [_c("introduction-card", {
      key: index,
      attrs: {
        isReverse: index % 2 !== 0,
        img: item.img,
        title: item.title,
        paragraph: item.paragraph
      }
    })];
  })], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("header", {
    staticClass: "stock-introduction__header"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("全国领先的互联网金融信息服务提供商")]), _c("p", [_vm._v(" 同花顺提供的自选股同步标准解决方案，上线到券商后，不仅可以解决iOS、安卓、PC各客户端的自选股同步问题，还能通过智能匹配，解决同花顺与第三方服务的自选股同步转化问题。 ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };